import {Injectable} from '@angular/core';
import {Action, Selector, State, StateContext, Store} from '@ngxs/store';
import {WicketOfferItem} from '@tisa-group/models';
import {ClearOfferItems, FetchOfferItems} from './offer-items.actions';
import {map, tap} from 'rxjs/operators';
import {Observable} from 'rxjs';
import {ClientPaymentsApiService} from '@tisa-group/core/api/wicket/client-payments-api/client-payments-api.service';
import {environment} from '@environments/environment';
import {LanguageService} from '@core/services/language.service';

export type OfferItemsStateModel = WicketOfferItem[] | null;

@State<OfferItemsStateModel>({
  name: 'OfferItems',
  defaults: null,
})
@Injectable()
export class OfferItemsState {
  @Action(FetchOfferItems)
  loadOfferItems(
    ctx: StateContext<OfferItemsStateModel>,
    {chargeBeeFamillyId}: FetchOfferItems,
  ): Observable<OfferItemsStateModel> | OfferItemsStateModel {
    const state = ctx.getState();

    if (state) {
      return state;
    }

    return this.paymentService
      .fetchOfferItems(
        chargeBeeFamillyId,
        this.languageService.currentLanguage$.getValue(),
      )
      .pipe(
        map(({data}) => data),
        tap(data => ctx.setState(data)),
      );
  }

  @Action(ClearOfferItems)
  clearOfferItems(ctx: StateContext<OfferItemsStateModel>) {
    return ctx.setState(null);
  }

  @Selector()
  static offerItems(state: OfferItemsStateModel): OfferItemsStateModel {
    return state;
  }

  constructor(
    readonly paymentService: ClientPaymentsApiService,
    readonly languageService: LanguageService,
  ) {}
}
